const mudouEnderecoDefault = {
  mudouIdentificacao: false,
  mudouNumero: false,
  mudouBairro: false,
  mudouComplemento: false,
  mudouUF: false,
  mudouCEP: false,
  mudouLogadouro: false,
  mudouMunicipio: false
}

const mudouResponsavelPessoaJuridica = {
  mudouNome: false,
  mudouCPF: false,
  mudouTelefones: false,
  mudouEmail: false
}

const mudouPessoaDefault = {
  mudouNumeroCertidaoCasamento: false,
  mudouDataCasamento: false,
  mudouCPF: false,
  mudouApelido: false,
  mudouNomeSocial: false,
  mudouRG: false,
  mudouOrgaoExpedidor: false,
  mudouNacionalidade: false,
  mudouEstadoCivil: false,
  mudouDataNascimento: false,
  mudouNaturalidade: false,
  mudouTelefones: false,
  mudouNomeDoPai: false,
  mudouNomeDaMae: false,
  mudouTempoMoradia: false,
  mudouEmail: false,
  mudouOrgao: false,
  mudouCNPJ: false,
  mudouRazaoSocial: false,
  mudouNome: false,
  mudouTemCertidaoObito: false,
  mudouMatricula: false,
  mudouResponsavelPessoaJuridica: mudouResponsavelPessoaJuridica,
  mudouEndereco: mudouEnderecoDefault
}
const mudouProdutividadeDefault = {
  mudouTipo: false,
  mudouNumeroDAP: false,
  mudouNumeroDRP: false,
  mudouDocumentosDestinacaoUsoImovel: false
}
const mudouEnderecoImovelDefault = {
  mudouTipoLogradouro: false,
  mudouLoteamantoVila: false,
  mudouNumero: false,
  mudouComplemento: false,
  mudouBairro: false,
  mudouQuadra: false,
  mudouLote: false
}
const mudouTerrenoDefault = {
  mudouLocalizacao: false,
  mudouDelimitacao: false,
  mudouDelimitacaos: false,
  mudouSituacao: false,
  mudouCalcadaExterna: false,
  mudouTopografia: false,
  mudouQuintalAreaLivre: false,
  mudouTotalUnidades: false,
  mudouPossuiPiscina: false,
  mudouPossuiAnexo: false
}
const mudouUnidadeDefault = {
  mudouTipoUnidade: false,
  mudouSituacao: false,
  mudouDisposicao: false,
  mudouImplantacao: false,
  mudouTipologia: false,
  mudouQtdPavimento: false,
  mudouPadraoConstrutivo: false,
  mudouConservacao: false,
  mudouUsoSolos: false,
  mudouOutroUsoSolo: false
}
const mudouConstrucaoDefault = {
  mudouCoberturas: false,
  mudouEstruturas: false,
  mudouParedes: false,
  mudouRevestimentos: false,
  mudouFornecimentoEnergia: false,
  mudouUtilizacaoSanitario: false,
  mudouLocalizacaoSanitario: false,
  mudouUtilizacaoSanitarios: false,
  mudouLocalizacaoSanitarios: false,
  mudouPisos: false,
  mudouForros: false,
  mudouNumCompartimentos: false,
  mudouNumQuartos: false,
  mudouNumSanitarios: false,
  mudouOutroEstrutura: false
}

const mudouInteressadoDTODefault = {
  mudouPessoa: mudouPessoaDefault,
  mudouEndereco: mudouEnderecoDefault,
  mudouSocioRepresentanteLegal: false,
  mudouMembroFamilia: false,
  mudouRendaFamiliarInteressado: false,
  mudouConjugeInteressado: mudouPessoaDefault,
  mudouPossuiConjugeInteressado: false,
  mudouEspolioInteressado: false,
  mudouDocumentosInteressado: false

}
const mudouCadastranteDTODefault = {
  mudouPessoa: mudouPessoaDefault,
  mudouEndereco: mudouEnderecoDefault,
  mudouTipoCadastrante: false,
  mudouRepresentanteLegal: false,
  mudouDocumentosCadastrante: false,
  mudouMembroComunidade: false
}
const mudouGeorreferenciamentoDTODefault = {
  mudouNomeResponsavel: false,
  mudouCpfResponsavel: false,
  mudouCreaRnp: false,
  mudouFormacao: false,
  mudouCodigoIncra: false,
  mudouDocumentosGeorreferenciamento: false
}
const mudouDestinacaoUsoImovelDTODefault = {
  mudouPossuiReservaLegal: false,
  mudouAreaReservaLegal: false,
  mudouPercentualAreaReservaLegal: false,
  mudouTotalAreaEmUso: false,
  mudouProdutividade: mudouProdutividadeDefault,
  mudouCulturaPermanente: false,
  mudouCulturaTemporaria: false,
  mudouSemovente: false,
  mudouOutrasAtividade: false,
  mudouEdificacoes: false,
  mudouDestinacaoImovelCheckeds: false
}
const mudouQualificacaoDTODefault = {
  mudouArea: false,
  mudouRenda: false,
  mudouCargoPublico: false,
  mudouPossuiImovelRuralTitulado: false,
  mudouOcupaImovel: false,
  mudouExploracaoAgricola: false,
  mudouBeneficiarioOriginario: false,
  mudouAreaGeorreferenciada: false,
  mudouAreaMatriculada: false,
  mudouPertenceAoProjeto: false,
  mudouBeneficiarioOriginal: false,
  mudouPagoIntegral: false,
  mudouMunicipio: false
}
const mudouImovelDTODefault = {
  mudouPossuiCar: false,
  mudouNumeroReciboCar: false,
  mudouNome: false,
  mudouMunicipio: false,
  mudouArea: false,
  mudouFinalidadesImovel: false,
  mudouDescricaoAcesso: false,
  mudouPossuiImovel: false,
  mudouOcupantesAnteriores: false,
  mudouConflitos: false,
  mudouNumeroProcessoJudicial: false,
  mudouTempoOcupacao: false,
  mudouCNSMatricula: false,
  mudouNumeroMatricula: false,
  mudouLivroMatricula: false,
  mudouNumeroFolhaMatricula: false,
  mudouNomeBeneficiarioTitulo: false,
  mudouNumeroTitulo: false,
  mudouAreaTitulo: false,
  mudouDataExpedicaoTitulo: false,
  mudouModalidadeTitulo: false,
  mudouDocumentosImovel: false,
  mudouDestinacaoUsoImovel: mudouDestinacaoUsoImovelDTODefault,
  mudouNomeImovelPropriedade: false,
  mudouCausasImpossibilidadeOcupacao: false,
  mudouDenominacao: false,
  mudouNomeColonia: false,
  mudouLocalizacao: false,
  mudouEnderecoImovel: mudouEnderecoImovelDefault,
  mudouAreaConstruida: false,
  mudouOcupacao: false,
  mudouEstadoImovel: false,
  mudouDominilidade: false,
  mudouRegimeUso: false,
  mudouTerreno: mudouTerrenoDefault,
  mudouUnidade: mudouUnidadeDefault,
  mudouConstrucao: mudouConstrucaoDefault,
  mudouSistemaSanitario: false,
  mudouDestinacaoLixos: false,
  mudouAbastecimentoAgua: false,
  mudouArborizacao: false,
  mudouAquisicao: false,
  mudouPossuiAlvara: false,
  mudouObservacoesGerais: false
}

const mudouEnderecoDTODefault = {
  mudouNumero: false,
  mudouBairro: false,
  mudouComplemento: false,
  mudouUF: false,
  mudouCEP: false,
  mudouLogadouro: false,
  mudouMunicipio: false
}

const compararRetificacoesDefault = {
  mudouPessoa: mudouPessoaDefault,
  mudouInteressadoDTO: mudouInteressadoDTODefault,
  mudouCadastranteDTO: mudouCadastranteDTODefault,
  mudouGeorreferenciamentoDTO: mudouGeorreferenciamentoDTODefault,
  mudouDestinacaoUsoImovelDTO: mudouDestinacaoUsoImovelDTODefault,
  mudouQualificacaoDTO: mudouQualificacaoDTODefault,
  mudouImovelDTO: mudouImovelDTODefault,
  mudouEndereco: mudouEnderecoDTODefault
}
export default () => { return compararRetificacoesDefault }



// WEBPACK FOOTER //
// ./src/utils/pa/compararReticacoesDefault.js